import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getUserFromNumber } from "../../../database/helpers/user";
import { Box, CircularProgress } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useAuthContext } from "../../../context/AuthContext";
import { initDemo } from "../../../helper/demoHelper";
import Cookies from "js-cookie";

const UnAuthenticateRoute = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const { setBusiness, setUser } = useAuthContext();

  useEffect(() => {
    const url = window.location.href;
    if (url.includes("web-demo")) {
      initDemo({ setUser, setBusiness, navigate, location });
    }
  }, []);

  useEffect(() => {
    let number = localStorage.getItem("phone_number");

    if (!number) {
      setIsLoading(false);
      return;
    }

    getUserFromNumber(number)
      .then((res) => {
        if (res.length && res[0].phone_number === number && res[0].is_active) {
          // Registered user: if /VerifyPin is already in the history stack, go back
          // to it instead of pushing/replacing with a new entry — prevents duplicate
          // stack entries.
          const canGoBack = window.history.state?.idx > 0;
          if (sessionStorage.getItem("verifyPinInStack") === "1" && canGoBack) {
            navigate(-1);
            // Safety net: navigate(-1) only lands on /VerifyPin when it's actually
            // the immediately preceding history entry. The flag can be stale (set
            // earlier in the session), in which case -1 goes nowhere useful and this
            // component never remounts to re-check — leaving the loader stuck
            // forever. Verify shortly after and force a deterministic redirect if
            // we didn't actually land on /VerifyPin.
            setTimeout(() => {
              if (window.location.pathname.toLowerCase() !== "/verifypin") {
                sessionStorage.setItem("verifyPinInStack", "1");
                navigate("/VerifyPin", { replace: true });
              }
            }, 300);
          } else {
            sessionStorage.setItem("verifyPinInStack", "1");
            navigate("/VerifyPin", { replace: true });
          }
        } else {
          const tempUserId = Cookies.get("tempUserId");
          if (tempUserId) {
            const lastVisited = localStorage.getItem("lastVisited");
            navigate(lastVisited || "/BusinessOverview", { replace: true });
          } else {
            setIsLoading(false);
          }
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      height={"100vh"}
    >
      <CircularProgress />{" "}
    </Box>
  ) : (
    <Outlet />
  );
};

export default UnAuthenticateRoute;
